import { createContext } from "react";

export const ObjectiveModalContext = createContext();
